import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { NavigatePathConstant } from 'src/constants';
import { useSubmittedAccountSelector } from 'src/hooks';

import { OFFER_ORDERS_PATH } from './NewOfferOrderGuard';

export const CanActivateSummaryGuard = () => {
  const redirectToOfferOrder: string | null = useSelector((state: any) => state.app.redirectToOfferOrder);
  const redirectToOffer: string[] = useSelector((state: any) => state.app.redirectToOffer);
  const redirectToEmailConfirm: { confirm: string; updateId: number } | null = useSelector(
    (state: any) => state.app.redirectToEmailConfirm,
  );
  const { account } = useSubmittedAccountSelector();

  if (redirectToOfferOrder && account.type.isEntity && !account.isEntityAccountTypeActive) {
    return <Navigate to={`/offers/${redirectToOfferOrder}`} />;
  }

  if (redirectToOfferOrder) {
    return <Navigate to={`/${NavigatePathConstant.MAIN}/${OFFER_ORDERS_PATH}/${redirectToOfferOrder}/orders/new`} />;
  }

  if (redirectToEmailConfirm) {
    const { confirm, updateId } = redirectToEmailConfirm;

    return <Navigate to={`/email-confirm?confirm=${confirm}&id=${updateId}`} />;
  }

  if (redirectToOffer) {
    return <Navigate to={`/offers/${redirectToOffer}`} />;
  }

  return <Outlet />;
};
